<template>
    <div v-if="invoice">
        <b-modal
            size="lg"
            v-model="modalShow"
            title="お支払いの再試行"
            ok-title="お支払いを確定"
            ok-variant="yokumiru-orange"
            cancel-title="キャンセル"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="cancel"
            @hidden="cancel">
            <form @submit.stop.prevent="retryPayment">
                <div class="d-flex justify-content-between">
                    <div>請求日時：</div>
                    <div>{{ helper.dateTimeForHuman(invoice.finalized_at, timezone) }}</div>
                </div>

                <hr class="mt-1 mb-1">

                <div class="d-flex justify-content-between">
                    <div>請求内容：</div>
                    <div>{{ invoice.content }}</div>
                </div>

                <hr class="mt-1 mb-3">

                <div class="d-flex justify-content-between">
                    <div class="font-weight-bold">料金：</div>
                    <div class="font-weight-bold">
                        <span>{{ invoice.total.toLocaleString() }}</span>
                        <span class="small">円</span>
                    </div>
                </div>

                <div
                    v-if="errors.stripe"
                    class="invalid-feedback d-flex justify-content-center mt-3">
                    <div v-if="errors.stripe.code === 'card_declined'">カード会社によって支払いが拒否されました。</div>
                    <div v-else-if="errors.stripe.type === 'card_error'">このカードは利用できません。</div>
                    <div v-else-if="errors.stripe.message === 'Invoice is already paid'">既に支払い済みの請求書です。</div>
                    <div v-else-if="['api_connection_error', 'api_error'].includes(errors.stripe.type)">
                        決済システムのメンテナンス中です。時間を置いて再度お試しください。
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import constants from "../../../constants"
    import YokumiruHelper from '../../../YokumiruHelper'
    import {loadStripe} from '@stripe/stripe-js'

    export default {
        name: "RetryPaymentModal",
        props: {
            pubkey: {
                type: String,
                required: true,
            },
            timezone: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                inProgress :false,
                modalShow: false,
                invoice: null,
                stripe: null,
                errors: {},
            }
        },

        created: async function () {
            this.stripe = await loadStripe(this.pubkey, {locale: "ja"})
            bus.$on('open-modal-retry-payment', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-retry-payment')
        },

        methods: {
            open: function (invoice) {
                this.invoice = invoice
                this.modalShow = true
            },

            handleOk(e) {
                e.preventDefault()
                this.retryPayment()
            },

            retryPayment: async function () {
                if (this.inProgress) return
                this.inProgress = true

                axios.post(`${constants.user.invoices.endpoint.base}/${this.invoice.id}/pay`)
                    .then(({data}) => {
                        if (data.data.success) {
                            bus.$emit('retry-payment-completed', data.data.invoice)
                            bus.$emit('alert-success', 'お支払いが完了しました。')
                            this.close()
                            this.inProgress = false
                        }
                        else {
                            // 3DS認証フロー
                            // @see https://github.com/sewii/Yokumiru/issues/987
                            this.stripe
                                .confirmCardPayment(data.data.client_secret, {
                                    payment_method: data.data.payment_method,
                                })
                                .then((result) => {
                                    if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
                                        bus.$emit('retry-payment-completed', data.data.invoice)
                                        bus.$emit('alert-success', 'お支払いが完了しました。')
                                        this.close()
                                    }
                                    else {
                                        bus.$emit('alert-danger', '3Dセキュア認証がキャンセルされました。')
                                    }
                                    this.inProgress = false
                                })
                        }
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger', '支払いに失敗しました。')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                        this.inProgress = false
                    })
            },

            cancel: function () {
                this.initialize()
                this.close()
            },

            close: function () {
                this.initialize()
                this.modalShow = false
            },

            initialize: function() {
                this.invoice = null
                this.errors = {}
            },
        },
    }
</script>

<style scoped lang="scss">
    @media only screen and (min-width: 992px) {
        .mb-errors {
            margin-bottom: 22px;
        }
    }
</style>
